<script>
import { donationCurrencySymbol, formatDonationAmount } from '@/constants/currencies.js'
import TwButton from '../../generic/tw-button.vue'

export default {
  name: 'DonateAmountField',
  components: { TwButton },
  props: {
    modelValue: {
      type: [String,Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(7)
    },
    required: {
      type: Boolean,
      default: false
    },
    prepend: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    },
    currency: {
      type: String,
      default: 'USD'
    }
  },
  emits: ['update:modelValue', 'update'],
  computed: {
    textSize() {
      return [
        {'text-sm': !this.size},
        {'text-2xl': this.size === 'lg'},
        {'text-sm': this.size === 'sm'},
      ]
    },
    colors() {
      return [
        {'text-amber-500': this.modelValue > 0 },
        {'text-gray-300': this.modelValue === 0 },
      ]
    },
    inputClasses() {
      return [
        'h-[4.5rem] md:h-[5.5rem] p-0 leading-1 donate-amount-field block ring-0 focus:ring-0 focus:bg-white w-full font-medium border-0 border-b-2 focus:border-gray-800 border-gray-800 placeholder:text-gray-400 bg-white text-center',
        '[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none',
        {'text-sm': !this.size},
        {'text-6xl font-semibold': this.size === 'lg'},
        {'': this.size === 'sm'},
        ...this.colors,
        // width of the input based on the length of the content,
        // this is a hack to make the input field width dynamic

      ]
    },
    fieldWidth() {
      const digits = String(this.modelValue).replace('.', '').length;
      if(digits > 1) {
        return Math.ceil(digits*3)
      }
      else {
        return 7
      }
    },
    fieldStyle() {
      return {
        width: `${this.fieldWidth}rem`
      }
    },
    availableSuggestedAmounts() {
      return [50,100,250,500,1000]
    },
    currencySymbol() {
      return donationCurrencySymbol(this.currency)
    }
  },
  mounted() {
    this.$refs.field.focus()
  },
  methods: {
    resetAndFocus() {
      this.$emit('update:modelValue',0)
      this.$refs.field.focus()
    },
    formatSuggestedAmount(amount) {
      return formatDonationAmount(amount, this.currency, { maximumFractionDigits: 0 })
    }
  }
}
</script>

<template>
  <h4 class="text-center">
    Enter your Donation Amount:
  </h4>
  <div class="flex flex-row justify-center">
    <span :class="[...colors, ...textSize, 'mt-5']">{{ currencySymbol }}</span>
    <div class="">
      <input
        :id="id"
        ref="field"
        :style="fieldStyle"
        pattern="(?:0|[1-9]\d*)"
        inputMode="decimal" autoComplete="off" :required="required"
        :value="modelValue" type="number" :name="id"
        :class="inputClasses" :placeholder="placeholder"
        @input="$emit('update:modelValue', $event.target.value)"
      >
    </div>
  </div>

  <div class="grid grid-cols-3 gap-4 mt-4">
    <tw-button v-for="suggestedAmount in availableSuggestedAmounts" :key="'suggested-amount-key-' + suggestedAmount" :fa-icon="suggestedAmount === modelValue? 'check':null" :variant="suggestedAmount === modelValue? 'success':'primary'" @click="$emit('update:modelValue',suggestedAmount)">
      {{ currencySymbol }} {{ formatSuggestedAmount(suggestedAmount) }}
    </tw-button>
    <tw-button :fa-icon="modelValue !== 0 && availableSuggestedAmounts.indexOf(modelValue) === -1? 'check':null" :variant="modelValue !== 0 && availableSuggestedAmounts.indexOf(modelValue) === -1? 'success':'primary'" @click="resetAndFocus">
      Other
    </tw-button>
  </div>
</template>

<style scoped>

</style>
